import { CcResponse } from "server/models"

export type CcResponseTranslation = { [langId: string]: string }
export type CcResponseValidation = { [key in keyof CcResponse]?: string}

export interface CcModuleResponseList { [moduleId: number]: readonly number[] }
export interface CcResponseList { [responseId: number]: CcResponse }

export interface CcResponseState {
    moduleResponseList: CcModuleResponseList

    responseList: CcResponseList
    responseEdit: CcResponse

    reloadList: boolean
    reloadEdit: boolean
}

export const CC_MODULE_RESPONSE_LIST = "CC_MODULE_RESPONSE_LIST"

export const CC_RESPONSE_LIST = "CC_RESPONSE_LIST"
export const CC_RESPONSE_EDIT = "CC_RESPONSE_EDIT"

export const CC_RESPONSE_RELOAD_LIST = "CC_RESPONSE_RELOAD_LIST"
export const CC_RESPONSE_RELOAD_EDIT = "CC_RESPONSE_RELOAD_EDIT"
